export type ListOrder = 'name' | 'updated'

export type ListFilterMode = 'all' | 'only_unchecked' | 'modified_in_last_hour' | 'modified_today'

export interface ListSettings {
    order: ListOrder,
    filter: ListFilterMode
}

export const defaultListSettings: ListSettings = {
    order: 'name',
    filter: 'all'
}

const storageKey = (listId: string) => `listSettings_${listId}`

export function loadListSettings(listId: string): ListSettings {
    try {
        const stored = localStorage.getItem(storageKey(listId))

        if (stored !== null) {
            return Object.assign({}, defaultListSettings, JSON.parse(stored))
        }
    } catch (e) {
        console.error('Error on loading list settings', e)
    }

    return defaultListSettings
}

export function saveListSettings(listId: string, settings: ListSettings) {
    try {
        localStorage.setItem(storageKey(listId), JSON.stringify(settings))
    } catch (e) {
        console.error('Error on saving list settings', e)
    }
}
